import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
export default {
  props: {
    info: Object,
    sendReceiverInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    loadingBtn: {
      type: Boolean,
      default: false,
      galleryStatus: ''
    },
    pageNum: {
      type: Number,
      default: 1
    },
    showAudioHtml: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true,
      enableList: [],
      defaults: {
        Default: 'Live Source',
        group: 'Live Source',
        Gallery: 'Gallery'
      },
      loading: true,
      sdiActive: true,
      clickType: '',
      outputStatus: '',
      galleryStatus: '',
      startLoading: false,
      audioType: 0,
      audioChannelByType: {},
      channelCount: '',
      currentChannelCount: '',
      mixMinusContent: this.$t('common.mixControl'),
      sourceType: '',
      selectSource: '',
      pgmNameInfo: {},
      // 为了选择 pp 新逻辑添加的，因为要显示的名字和发送的名字不一样
      encoderList: []
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      currentPartyInfo: state => state.currentPartyInfo
    }),
    returnStatus() {
      let flag = false;
      if (this.info.params.receiverId == this.sendReceiverInfo.outputRid && this.sendReceiverInfo.outputSourceType && this.sendReceiverInfo.outputSourceType == this.selectSource && this.currentChannelCount == this.channelCount) {
        flag = true;
      }
      if (this.info.sourceType === 'PGM') {
        // 为了 mainWindow 可以选择 slot 新增判断逻辑
        let select = '';
        this.encoderList.forEach(item => {
          if (item.name == this.sendReceiverInfo.outputSourceType) {
            select = item.slotNo;
          }
        });
        if (this.info.params.receiverId == this.sendReceiverInfo.outputRid && select == this.selectSource && this.sendReceiverInfo.outputSourceType && this.currentChannelCount == this.channelCount) {
          flag = true;
        }
      }
      return flag;
    }
  },
  watch: {
    loadingBtn(val) {
      if (val === false) {
        if (!this.enableList.includes('group') && this.galleryStatus == 'send') {
          this.galleryStatus = '';
        }
        if (this.galleryStatus == 'stop') {
          this.galleryStatus = '';
        }
        if (this.outputStatus == 'stop') {
          this.selectSource = '';
          this.outputStatus = '';
        }
      }
    }
  },
  async created() {
    this.loading = true;
    if (this.$route.name.includes('group') || this.$route.name == 'kiosk') {
      let params = null;
      const url = this.$route.name.includes('group') ? '/partyline-backend/group/noLogin/v3/status' : '/partyline-backend/kiosk/noLogin/status';
      if (this.$route.name.includes('group')) {
        params = {
          groupId: this.currentPartyInfo.code,
          pageNum: this.pageNum
        };
      } else {
        params = {
          partyCode: this.currentPartyInfo.code,
          pageNum: this.pageNum
        };
      }
      await this.axios.post(url, params).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          this.sendReceiverInfo.outputRid = result.outputRid;
          this.sendReceiverInfo.outputSourceType = result.outputSourceType;
        }
      });
      await this.getEncoderSourcesV2();
    } else {
      await this.getEncoderSourcesV2();
    }
    this.getEncoderInfo();
  },
  methods: {
    returnClass(name) {
      let str = '';
      if (this.info.sourceType == 'PGM') {
        name === 'PGM (mix minus)' || name === 'PGM' ? str = 'w_50' : str = 'w_25';
      } else {
        str = 'w_33';
      }
      return str;
    },
    returnLabel(val) {
      if (!val) return;
      if (val === 'Default') {
        return 'Live Source';
      } else if (val == 'VoIP') {
        return 'No Video';
      } else {
        if (this.info.sourceType === 'PGM') {
          if (val === 'PGM (mix minus)' || val === 'PGM') {
            return val;
          } else {
            return val.replace('s', 'Slot');
          }
        } else {
          return val;
        }
      }
    },
    getEncoderInfo() {
      if (!this.info.params.receiverId) {
        this.loading = false;
        return;
      }
      this.axios.get(`/partyline-backend/receiver/encoder?rid=${this.info.params.receiverId}`).then(res => {
        if (res.data.errorCode === '0x0') {
          if (!res) return;
          this.loading = false;
          const result = res.data.result;
          if (result && result.length) {
            const encoderInfo = result.filter(item => {
              return item.code == this.currentPartyInfo.code;
            });
            encoderInfo.forEach(item => {
              this.channelCount = item.partyEncoder.Audio.Tracks[0] || 1;
            });
            if (!encoderInfo.length) {
              this.channelCount = 1;
            }
          } else {
            this.channelCount = 1;
          }
          this.currentChannelCount = this.channelCount;
        }
      }).catch(e => {
        this.loading = false;
        console.log(e);
      });
    },
    async getEncoderSourcesV2() {
      await this.axios.get(`/partyline-backend/receiver/getEncoderSourcesV2/${this.info.params.receiverId}?productionId=${this.info.productionId}`).then(res => {
        if (res.data.errorCode === '0x0') {
          this.enableList = [];
          const result = res.data.result || [];
          this.encoderList = result;
          this.pgmNameInfo = {};
          result.forEach(v => {
            if (this.info.sourceType == 'PGM') {
              // 根据最新 UI 更改为增加显示所有 slot
              if (v.name == 'PGM') {
                this.pgmNameInfo.PGM = 'PGM';
                this.audioChannelByType.PGM = v.audioChannelCount / 2;
                this.audioChannelByType['PGM (mix minus)'] = v.audioChannelCount / 2;
              } else if (v.name != 'PVW') {
                this.pgmNameInfo[v.slotNo] = v.name;
                this.enableList.push(v.slotNo);
                this.audioChannelByType[v.slotNo] = v.audioChannelCount / 2;
              }
              if (this.info.params.receiverId == this.sendReceiverInfo.outputRid) {
                if (this.sendReceiverInfo && this.sendReceiverInfo.outputSourceType == v.name) {
                  this.selectSource = v.slotNo;
                }
              }
            } else {
              this.audioChannelByType[v.name] = v.audioChannelCount / 2;
              if (this.$route.name === 'group') {
                if (v.name != 'Gallery') {
                  this.enableList.push(v.name);
                }
              } else {
                this.enableList.push(v.name);
              }
            }
          });
          if (this.info.sourceType == 'PGM') {
            this.enableList = this.enableList.sort((item1, item2) => {
              if (Number(item1.slice(1)) < Number(item2.slice(1))) {
                return -1;
              } else if (Number(item1.slice(1)) == Number(item2.slice(1))) {
                return 0;
              } else {
                return 1;
              }
            });
            this.enableList.unshift('PGM');
            this.enableList.unshift('PGM (mix minus)');
          } else {
            if (this.$route.name === 'group') {
              this.enableList.push('VoIP');
            }
          }
          // if (this.info.params.receiverId != this.sendReceiverInfo.outputRid) {
          this.selectSource = this.enableList[0];
          // }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    select(val) {
      if (!this.enableList.includes(val)) return;
      this.selectSource = val;
    },
    cancel() {
      this.info.show = false;
      this.$emit('updateVfbData', {
        type: ''
      });
    },
    save() {
      this.$emit('updateTagStage');
      if (this.info.sourceType === 'PGM') {
        if (this.selectSource === 'PGM (mix minus)') {
          this.sourceType = 'PGM';
        } else if (this.selectSource === 'PGM') {
          this.sourceType = 'StudioOutput';
        } else {
          this.sourceType = this.pgmNameInfo[this.selectSource];
        }
      } else {
        this.sourceType = this.selectSource;
      }
      this.clickType = 'vfb';
      this.outputStatus = 'stop';
      if (this.returnStatus) {
        this.$emit('updateVfbData', {
          type: this.info.sourceType,
          source: this.sourceType,
          output: true,
          mode: this.selectSource == 'group' ? 'group' : 'SDI',
          currentRId: this.info.currentRId,
          callback: this.callback,
          operateType: 'stop'
        });
      } else {
        this.outputStatus = 'send';
        let trackIds = [];
        if (this.audioChannelByType[this.selectSource] <= 1 || !this.channelCount) {
          trackIds = [];
        } else {
          trackIds = [this.channelCount];
        }
        this.$parent.updateVfbData({
          type: this.info.sourceType,
          source: this.sourceType,
          output: true,
          operateType: 'send',
          trackIds: trackIds,
          mode: this.selectSource == 'group' ? 'group' : 'SDI',
          currentRId: this.info.currentRId,
          callback: this.callback,
          channelCount: this.channelCount
        });
      }
    },
    callback(obj) {
      if (obj.type == 'SDIOut') {
        if (obj.operateType == 'stop') {
          this.enableList = this.enableList.filter(v => v != 'group');
        } else {
          if (!this.enableList.includes('group')) this.enableList.unshift('group');
        }
      }
      if (obj.trackIds) {
        this.currentChannelCount = obj.trackIds[0];
      }
      this.info.show = false;
    }
  }
};